export default __webpack_public_path__ + "static/media/Venturer's Arm-straps of Grinning Skulls.a9a2e9b2.jpg";